<div class="card custom-card">
  <!-- Replaces nb-card-header -->
  <div class="custom-card-header">
    <h3>Edit Dispatch Number<i class="fas fa-pen fa-xs ms-2"></i></h3>
  </div>

  <!-- Replaces nb-card-body -->
  <div class="custom-card-body position-relative">
    <!-- Spinner overlay placeholder -->
    <div class="loading-overlay">
      <i class="fas fa-spinner fa-spin"></i>
    </div>

    <div class="form-group row" style="margin-top: 10px">
      <div class="col-12">
        <!-- Replaces mat-form-field -->
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-right-0 h-100">
              <i class="fas fa-phone-alt"></i>
            </span>
          </div>
          <input
            type="text"
            class="form-control"
            placeholder="Phone Number"
            [(ngModel)]="phoneNumber"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Replaces nb-card-footer -->
  <div class="custom-card-footer">
    <div class="row">
      <div class="col-12 text-end">
        <button class="save-button" (click)="save()">
          <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>
          Save
        </button>
      </div>
    </div>
  </div>
</div>
